import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=11c7647d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=11c7647d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c7647d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c7647d')) {
      api.createRecord('11c7647d', component.options)
    } else {
      api.reload('11c7647d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=11c7647d&scoped=true&", function () {
      api.rerender('11c7647d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z3UWBOL9XJQS/JS/comp/GuestBox.vue"
export default component.exports